const tools = require('../../tools')

exports.listWarehouseStock = listWarehouseStock
async function listWarehouseStock (
  state,
  mainApi,
  { locationId, programId, date } = {}
) {
  tools.validateParams('listWarehouseStock', arguments[2])

  const referenceDate = date || new Date().toJSON()
  const ruleLevel = extractRuleLevel(locationId)

  const suppliers = await mainApi.location.pgAdapter.getSuppliersForLocation(
    locationId,
    ruleLevel,
    [programId]
  )

  const warehouse = suppliers[0] || null
  if (!warehouse) {
    console.warn(`No warehouse found supplying location ${locationId} for program ${programId}`)
    return { locationId, programId, warehouseId: null, sellPrices: [], genericGroups: [] }
  }

  // Pull sell prices for the warehouse.
  const priceList = await mainApi.price.location.getSellPriceList(warehouse.fsid, referenceDate)
  const sellPrices = priceList.sellPrices || []
  const skus = Array.from(new Set(
    sellPrices.map(price => price.productId.replace('product:', ''))
  ))

  // Map sku -> generic_id in PG, then group by generic_id.
  const genericMetaBySku = await mainApi.product.productSKU.getGenericIdsForSkus(skus)

  // Group products by generic_id (generic parent), including sell price info for each product.
  const genericGroups = tools.groupWarehouseProductsByGenericId({
    sellPrices,
    genericMetaBySku
  })

  return {
    locationId,
    programId,
    warehouseId: warehouse.fsid,
    sellPrices,
    genericGroups
  }
}

// Extract the state-level FSID from a location ID for use as the relationship rule scope.
// e.g. 'zone:south-south:state:anambra:lga:awka:sdp:test-sdp' → 'zone:south-south:state:anambra'
// Returns null when the location ID has no state segment (e.g. zone-level locations).
function extractRuleLevel (locationId) {
  const parts = locationId.split(':')
  const stateIdx = parts.indexOf('state')
  if (stateIdx === -1) return null
  return parts.slice(0, stateIdx + 2).join(':')
}
